import axios from 'axios';
import { env } from './env';

export const getFeatureFlagData = async () => {
  const url = `${env.apiUrl}/feature-flags`;
  try {
    const res = await axios({
      method: 'GET',
      url,
    });

    if (res.status !== 200 || !res.data) {
      return { error: 'failed' };
    }

    return res.data.data;
  } catch (err) {
    console.log('err', err);
    // This feature flags use case seems to be outdated, needs to be cleaned up.
    // But SPT is tightly coupled with this endpoint returning a result,so return this incase of any errors
    // This also makes SPT accessible for users when gitlab is under maintenance or down
    return [
      {
        name: 'pqe-updates',
        description: 'Changes to UI that are specific to PQE changes',
        active: true,
        version: 'new_version_flag',
        created_at: '2022-04-28T22:16:45.019Z',
        updated_at: '2022-07-26T23:52:43.289Z',
        scopes: [],
        strategies: [
          {
            id: 562,
            name: 'default',
            parameters: {},
            scopes: [
              {
                id: 1095,
                environment_scope: 'development',
              },
              {
                id: 1226,
                environment_scope: 'stage',
              },
              {
                id: 1260,
                environment_scope: 'production',
              },
            ],
            user_list: null,
          },
        ],
      },
    ];
  }
};
